import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

import Axios from "@/lib/axios-instance";

type APIPayload = {
    name?: string;
    avatar?: string;
    welcome_message?: string;
    widget_color?: string;
    widget_button_position?: string;
    widget_button_size?: string;
};

type ResponseType = {
    data: any;
    meta: any;
};

export const addLookAndFeel = async (payload: APIPayload) => {
    try {
        const response = await Axios.post(`/chat_widget_settings/look_and_feel`, payload);
        return response.data;
    } catch (error: any) {
        if (error.response) {
            throw new Error(`${error.response.data?.meta?.message || "An error occurred"}`);
        }
        throw new Error(error.message || "Network Error");
    }
};

export const useAddLookAndFeel = () => {
    const queryClient = useQueryClient();
    return useMutation<ResponseType, Error, APIPayload>({
        mutationFn: (payload: APIPayload) => addLookAndFeel(payload),
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ["get_widget_settings"] });
            toast.success("Settings Added Successfully");
            console.log(data);
        },
        onError: (error) => {
            toast.error("Adding Settings Failed", { description: error.message });
        },
    });
};
